import { useCallback } from "react";
import { TAG_EVENTS } from "shared/events";
import { usePostMessageConfig } from "./config";

const useOnQrModalClose = (cb) => {
	const { addHandler } = usePostMessageConfig();

	return useCallback(() =>
		addHandler(TAG_EVENTS.CLOSE_AR_QR_MODAL, cb), [cb]);
};

export default useOnQrModalClose;
